/**
 * 下層 .local__content 内の table を横スクロール用にラップし、
 * scroll-hint（.js-scrollable）でスクロール可能であることを示す。
 */
jQuery(function () {
  function wrapLocalTables() {
    jQuery('.local__content table').each(function () {
      var $table = jQuery(this);
      if ($table.parent().hasClass('local-table-scroll__track')) {
        return;
      }
      $table.wrap(
        '<div class="local-table-scroll__track js-scrollable"></div>'
      );
      $table.parent().wrap('<div class="local-table-scroll__trackWrap"></div>');
      $table.closest('.local-table-scroll__trackWrap').wrap(
        '<div class="local-table-scroll js-local-table-scroll"></div>'
      );
    });
  }

  wrapLocalTables();

  // 横スクロールの ScrollHint は SP のみ（PC は overflow しないためヒント不要）
  if (
    typeof window.ScrollHint !== 'undefined' &&
    window.matchMedia('(max-width: 767px)').matches &&
    document.querySelector('.js-scrollable')
  ) {
    new window.ScrollHint('.js-scrollable', {
      i18n: {
        scrollable: '横にスクロールできます',
      },
    });
    document.querySelectorAll('.local-table-scroll__track.js-scrollable').forEach(function (el) {
      el.style.overflowX = 'auto';
      el.style.overflowY = 'hidden';
    });
  }
});
